import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Home = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.57 3.464c.86-.619 2.03-.62 2.89.003l.018.012.016.013L43.67 19.62a.88.88 0 1 1-1.098 1.375l-3.264-2.609v19.391c0 2-1.894 3.357-3.867 3.357H8.56c-1.973 0-3.867-1.357-3.867-3.357V18.388L1.43 20.995A.88.88 0 0 1 .331 19.62L20.534 3.49l.018-.014.018-.013Zm1.845 1.419 15.132 12.095v20.798c0 .735-.783 1.597-2.107 1.597h-8.747V28.051c0-1.684-1.402-3.051-3.129-3.051h-3.128c-1.727 0-3.13 1.367-3.13 3.05v11.323H8.56c-1.324 0-2.107-.862-2.107-1.597V16.983l15.158-12.1a.718.718 0 0 1 .804 0Z"
  }));
});
Home.displayName = 'Home';
Home.defaultProps = {
  'aria-label': 'Home'
};
export default Home;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Home.js
// module id = 3186
// module chunks = 11